<template>
  <popup-container>
    <template slot="header">
      {{ $l.userPrefectureSelect }}
    </template>

    <div class="popup-option"
      v-for="(option, index) in options"
      :key="index"
      @click="select(option)">
      {{ option.get(locale) }}
    </div>
  </popup-container>
</template>

<script>
import PopupContainer from '@/components/Popup/Container'
import MixinLocale from '@/components/MixinLocale'
import MixinIsSettingsUser from '@/components/Settings/MixinIsSettingsUser'

export default {
  mixins: [
    MixinLocale,
    MixinIsSettingsUser
  ],

  components: {
    PopupContainer
  },

  created: function () {
    this.$store.dispatch('country/retrievePrefectures')
  },

  computed: {
    options: function () {
      return this.$store.getters['country/prefectures']
    }
  },

  methods: {
    select: function (option) {
      this.$store.commit('user/setPrefecture', option)
      if (this.isSettingsUser) {
        this.$store.dispatch('user/savePrefecture', option)
      }
      this.$store.dispatch('popup/hide', null)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
